import { lazy, Suspense } from 'react';
import { createBrowserRouter, Outlet, type RouteObject } from 'react-router';
import { FullScreenSpinner } from './components/ui';
import NotFoundPage from './pages/NotFoundPage';
import RouteErrorPage from './pages/RouteErrorPage';

// Route-level code splitting keeps the player bundle small for phones.
const JoinPage = lazy(() => import('./pages/player/JoinPage'));
const PlayPage = lazy(() => import('./pages/player/PlayPage'));
const LibraryPage = lazy(() => import('./pages/host/LibraryPage'));
const EditorPage = lazy(() => import('./pages/host/EditorPage'));
const QuizPage = lazy(() => import('./pages/host/QuizPage'));
const GamePage = lazy(() => import('./pages/host/GamePage'));
const ConnectPage = lazy(() => import('./pages/host/ConnectPage'));
const AccountPage = lazy(() => import('./pages/host/AccountPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
// Dev-only visual previews of the game screens with mock data (not routed in production builds).
const PlayerPreview = import.meta.env.DEV ? lazy(() => import('./pages/dev/PlayerPreview')) : null;
const HostPreview = import.meta.env.DEV ? lazy(() => import('./pages/dev/HostPreview')) : null;

function RootLayout() {
  return (
    <Suspense fallback={<FullScreenSpinner />}>
      <Outlet />
    </Suspense>
  );
}

const devRoutes: RouteObject[] = [
  ...(PlayerPreview ? [{ path: '/dev/player', element: <PlayerPreview /> }] : []),
  ...(HostPreview ? [{ path: '/dev/host', element: <HostPreview /> }] : []),
];

// A data router (rather than <BrowserRouter>) so pages can use useBlocker, e.g. the
// quiz editor guarding unsaved changes against the browser Back button.
export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      { path: '/', element: <JoinPage /> },
      { path: '/play', element: <PlayPage /> },
      { path: '/host', element: <LibraryPage /> },
      { path: '/host/new', element: <EditorPage /> },
      { path: '/host/edit/:quizId', element: <EditorPage /> },
      { path: '/host/quiz/:quizId', element: <QuizPage /> },
      { path: '/host/game/:pin', element: <GamePage /> },
      { path: '/host/connect', element: <ConnectPage /> },
      { path: '/host/account', element: <AccountPage /> },
      { path: '/privacy', element: <PrivacyPage /> },
      ...devRoutes,
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
